import type { BadgeProps } from '@/components/ui/Badge'
import type { AdmissionStatus } from './types'

export const admissionStatusTone: Record<AdmissionStatus, NonNullable<BadgeProps['tone']>> = {
  submitted: 'info',
  reviewing: 'brand',
  waitlisted: 'warning',
  accepted: 'success',
  rejected: 'danger',
  enrolled: 'neutral',
}

/** English labels (i18n keys). */
export const admissionStatusLabel: Record<AdmissionStatus, string> = {
  submitted: 'Received',
  reviewing: 'Under review',
  waitlisted: 'Waiting list',
  accepted: 'Accepted',
  rejected: 'Not accepted',
  enrolled: 'Enrolled',
}

export const GUARDIAN_RELATIONS = [
  { value: 'mother', label: 'Mother' },
  { value: 'father', label: 'Father' },
  { value: 'local_guardian', label: 'Guardian' },
  { value: 'other', label: 'Other' },
] as const
